import { useState } from "react";

const UPLOAD_TOOLTIP_DESIGN_LAB_SESSION_KEY = "design-lab-processing-tooltip-dismissed";

/**
 * Check if tooltip was dismissed in this session
 */
const checkDismissalState = (): boolean => {
  try {
    return sessionStorage.getItem(UPLOAD_TOOLTIP_DESIGN_LAB_SESSION_KEY) === "true";
  } catch {
    return false;
  }
};

export function useProcessingTooltip(shouldShow: boolean) {
  const [isDismissed, setIsDismissed] = useState(checkDismissalState);

  const showTooltip = !isDismissed && shouldShow;

  const dismissTooltip = () => {
    setIsDismissed(true);
    try {
      sessionStorage.setItem(UPLOAD_TOOLTIP_DESIGN_LAB_SESSION_KEY, "true");
    } catch {
      // Fallback if sessionStorage is not available - silently fail
    }
  };

  return {
    showTooltip,
    dismissTooltip
  };
}
